export const API_URL = process.env.REACT_APP_API_URL;

export const LOGIN_VILNIUS_LOGIN: string = 'vilnius-login';
export const LOGIN_EVARTAI_LOGIN: string = 'evartai-login';

export enum LOGIN_ENDPOINTS {
  LOGIN_VILNIUS_LOGIN = 'login',
  LOGIN_EVARTAI_LOGIN = 'e-government/login',
}
